import { Component, OnInit, Inject, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FileService } from 'src/app/services/file.service';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DeleteConfirmModalComponent } from '../delete-confirm-modal/delete-confirm-modal.component';
import { MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
declare var $: any;
import * as moment from 'moment';
import * as _ from 'lodash';
import { SharedService } from 'src/app/shared.service';
import { AssetService } from 'src/app/services/asset.service';


@Component({
  selector: 'file-tile',
  templateUrl: './file-tile.component.html',
  styleUrls: ['./file-tile.component.scss']
})
export class FileTileComponent implements OnInit {



  @Input('materialObject') materialObject: any
  @Input('file') file: any;
  @Input('isCompetency') isCompetency;
  @Input('index') index;
  @Input('submissionIndex') submissionIndex;
  @Input('previousIndex') previousIndex: any;
  @Input('activeFile') activeFile: any;
  @Input('displayCheckBoxes') displayCheckBoxes: any;
  @Input('showDelete') showDelete;
  @Input('fileIndex') indexFile
  @Input('type') type
  // @Input('displayType') typeDisplay
  @Input('isdelete') isdelete
  @Input('accidentIndex') indexOfAccident
  @Input('displayType') userDocumentsType
  @Input('displayEvidence') evidenceShow
  @Input('isAsset') isAssets
  // @Input('displayType') typeDisplay
  @Output() deletedFile: EventEmitter<any> = new EventEmitter<any>();
  @Output() getFiles: EventEmitter<any> = new EventEmitter<any>();
  @Output() openSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileCheckEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() isAccidentIndex: EventEmitter<any> = new EventEmitter<any>();
  @Output() opened: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteUserDocs: EventEmitter<any> = new EventEmitter<any>();

  loading: boolean;
  allImagesArrayFlag: boolean = false;
  isSubmission = false;
  ismyDocs: boolean;
  isMaterial = false;
  pathForPreview: string;
  isReadingMaterial = false;
  currentUser;
  secledtIndex;
  isSingleFolder = false;
  isAccident: boolean = false
  isAsset: boolean = false
  fileExtensionArray = ['ppt', 'zip', 'pptx', 'mp4', 'xls', 'xlsx', 'txt', 'odt', 'png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'];
  user: any;
  isEviFile: boolean = true;
  quizImageArray = [];
  deletedImages = [];
  // isAccident: boolean;
  isDisplay: boolean = false
  evidenceFile: boolean = false
  isUserDocs: boolean = false
  userRole: any;
  fileType
  constructor(public dialogRef: MatDialogRef<any>, public _fileService: FileService, private route: ActivatedRoute, public router: Router,
    public dialog: MatDialog, public _snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public allImagesArray: any, public _assetService: AssetService) {
    if (this.allImagesArray && this.allImagesArray.isAllImage) {
      console.log("In file tile ", this.allImagesArray);
      this.quizImageArray = this.allImagesArray.imagesArray;
      console.log("this.quizImageArray ======> ", this.quizImageArray);
      this.allImagesArrayFlag = true;
    }
    else {
      this.allImagesArrayFlag = false;
    }

    console.log("data =============> constructor", this.allImagesArray)
    if (this.router.url.includes('submission') || this.router.url.includes('learner/allotment')) {
      console.log("1st if")
      this.isSubmission = true;
      this.isEviFile = false
    } else {
      this.isSubmission = false;
    }
    if (this.router.url.includes('job/view') || this.router.url.includes('material') ) {
      console.log("2st if")
      this.isMaterial = true;
      this.ismyDocs = false
      this.isEviFile = false
    }
    if (this.router.url.includes('mydocuments') || this.router.url.includes('labour-job/view') || this.router.url.includes('client/view')) {
      console.log("3st if")
      this.ismyDocs = true;
      this.isEviFile = false
      this.isMaterial = false
    }
    if (this.router.url.includes('learner/readingMaterial')) {
      console.log("4st if")
      this.isReadingMaterial = true;
      this.isEviFile = false
    }
    // || this.router.url.includes('labour-job/view')
    if (this.router.url.includes('/single-folder')) {
      console.log("5st if")
      this.isSingleFolder = true;
      this.isEviFile = false
    }
    else {
      console.log("6st if")
      this.isSingleFolder = false;
    }

    this.route.queryParams.subscribe(params => {
      console.log("param in file-details  ", params);
      if (params && params.userRole) this.userRole = params.userRole

    })


    // else this.ismyDocs = false
  }

  ngOnInit() {
    console.log("data =============> onINit", this.allImagesArray)
    console.log("In file tile ===> materialObject ==========> ", this.materialObject)
    console.log("In file tile ===> file ==========> ", this.file)
    console.log("In file tile ===> isCompetency ==========> ", this.isCompetency)
    console.log("In file tile ===> index ==========> ", this.index)
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.user = JSON.parse(localStorage.getItem('userRoles'))

    console.log("on init index is", this.file, this.index, this.showDelete);
    if (this.index == 0) {
      console.log("in if the index is", this.index);
      $('#' + this.index).addClass('cardBorder');
    }
    if (this.router.url.includes('/singleUnit')) {
      $('#fileTile').addClass('fileTitle')
    }
    else if (this.router.url.includes('/single-folder') || this.router.url.includes('labour-job/view')) {
      $('#fileTile').removeClass('fileTitle')
    }
    if (this.allImagesArrayFlag == false && this.file) {
      this.pathForPreview = "https://docs.google.com/gview?url=" + this.file.path + "&embedded=true"
      // if (this.file && this.file.alias) {\
      console.log("this files data here ==>", this.file)
      this.file.alias = (this.file.alias && this.file.alias.length > 1) ? this.file.alias : this.file.title
      // }
    }
    // console.log("file tile initialized file= ", this.file, this.index);

    // this._sharedService.deletedFile.subscribe(res => {
    //   if (!res) return
    //   else {
    //     console.log("res get in file-tile 1   ", res);
    //     if (this.file._id == res._id)
    //       this.file.isDeleted = true
    //   }
    // })
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.file && changes.file.currentValue) {
      this.file = changes.file.currentValue
      console.log("this is most important data to display", this.file);

    }
    // if (changes.materialObject && changes.materialObject.currentValue) {
    //   console.log("check metiral file data =====>",changes.materialObject.currentValue)
    // }

    if (changes.indexFile && changes.indexFile.currentValue) {
      console.log("what is the value of index pass", changes);
      this.secledtIndex = -1
      if (this.index == 0) {

        this.secledtIndex = this.index
        $('#' + this.index).addClass('cardBorder');
        $('.parent_row').addClass('col-width-class');
      }
    }
    if (changes.indexFile && changes.indexFile.currentValue == false) {
      this.secledtIndex = -1
    }
    if (changes.type) {
      this.type = changes.type.currentValue
    }
    // if (changes.typeDisplay && changes.typeDisplay.currentValue) {
    //   this.fileType = changes.typeDisplay.currentValue
    // }


    if (changes.userDocumentsType && changes.userDocumentsType.currentValue) {
      this.isUserDocs = true
      this.allImagesArrayFlag = false
      this.isSubmission = false
      this.isEviFile = false
      this.fileType = changes.userDocumentsType.currentValue
      console.log("CHANGES=======>>>>>>>", changes);
    }

    if (this.fileType == 'accident') this.isAccident = true
    if (this.fileType == 'asset') {
      this.isAsset = true; this.isUserDocs = false
    }
    if (changes.evidenceShow && changes.evidenceShow.currentValue) {
      this.evidenceFile = changes.evidenceShow.currentValue
    }
    console.log("what is the value of display", this.isUserDocs, this.isAsset);
    console.log("what is the value of this is userDocs", this.type);
    // if (this.type == 'competency') this.isEviFile = true, this.isSubmission = false, this.allImagesArrayFlag = false
  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log('OPENDIALOG', 'DATA = ', data)
    const dialogRef = this.dialog.open(someComponent, { data: 'file' });

    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ngAfterViewInit(): void {
    console.log("After view init");
    // this.previousIndex = 0
    // if (this.activeFile == true) {
    //   $('#0').addClass('cardBorder');
    // }
    // else {
    //   $('#0').removeClass('cardBorder');
    // }
  }


  delete() {
    this.openDialog(DeleteConfirmModalComponent).subscribe(confirm => {
      console.log("CONFIRM", confirm);
      if (confirm == '') return
      else if (confirm == 'yes') {
        if (this.isSubmission) {
          this._fileService.deleteSubmissionFiles(this.file._id).subscribe(file => {
            console.log("Deleted File. ID = ", this.file._id);
            this.loading = false;
            this.deletedFile.emit(this.file._id);
          }, err => {
            this.openSnackBar("Error deleting file.", "OK")
          });

        } else if (this.isUserDocs) {
          console.log("call this for assets");

          this.deleteUserDocs.emit(this.file._id)
        }
        else if (this.file.type == 'evidence') {
          this.deletedFile.emit(this.file._id);
          this.openSnackBar("File will be removed after save.", "OK")
        }
        else if (this.isAccident) {
          this.isAccidentIndex.emit(this.indexOfAccident)
          this.openSnackBar("File will be removed after save.", "OK")
        } else if (this.file.type == 'cpd') {
          this.deletedFile.emit(this.file);
          this.openSnackBar("File will be removed after save.", "OK")
        } else if (this.isCompetency) {
          this.deletedFile.emit(this.file)
        } else if (this.isAsset) {
          this.deletedFile.emit(this.file)
        }
        else {
          this._fileService.deleteFiles(this.file._id).subscribe(file => {
            console.log("Deleted File. ID = ", this.file._id);
            this.loading = false;
            this.deletedFile.emit(this.file._id);
          }, err => {
            this.openSnackBar("Error deleting file.", "OK")
          });
        }
      }
      else {
        return
      }
    })
  }

  viewFile() {
    console.log("File view in new tab", this.file);
    let url
    if (this.file && this.file.path) url = this.file.path
    else url = this.file.Location
    window.open(url, '_blank')
  }



  deleteImage(i) {
    this.quizImageArray[i].Location ? this.deletedImages.push(this.quizImageArray[i].Location) : this.deletedImages.push(this.quizImageArray[i])
    // this.deletedImages.push(this.quizImageArray[i].Location);
    this.quizImageArray.splice(i, 1);
  }

  removeAccidentFile() {
    console.log("this is the index of accident file", this.indexOfAccident);

  }

  viewImageClose() {
    this.dialogRef.close(this.deletedImages);
  }

  fileDetails(index) {
    console.log("this . material object => @file tile ", this.userRole);

    this.secledtIndex = index

    this.file['role'] = this.userRole

    console.log("this.secledtIndex", this.secledtIndex, index)
    // if (!this.ismyDocs){

    // }
    // else{
    $('#' + this.previousIndex).removeClass('cardBorder');
    if (this.submissionIndex != undefined) {
      console.log("call this or not", this.submissionIndex, "second one is important", this.index);
      $('#' + this.submissionIndex).addClass('cardBorder');
    } else {
      $('#' + this.index).addClass('cardBorder');
    }
    $('.parent_row').addClass('col-width-class');
    console.log("file tile clicked", event);
    // }

    this.openSideNav.emit({ materialObject: this.materialObject, file: this.file, isCompetency: this.isCompetency, index: this.index })
    this._fileService.displayFile({ event: {materialObject: this.materialObject, file: this.file, isCompetency: this.isCompetency, index: this.index} })
  }


  FileExtension(extension) {
    // console.log("extension ====> ", extension)
    let index = _.findIndex(this.fileExtensionArray, function (o) { return o == extension; });
    if (index >= 0) {
      return this.fileExtensionArray[index];
    } else {
      return 'default-extension';
    }
  }

  assetFileExtension(file) {

    // console.log("Single asset file", file);
    let extension = file.key.split('.')
    // console.log("After split the data", extension);
    let index = _.findIndex(this.fileExtensionArray, function (o) { return o == extension[1]; });
    if (index >= 0) {
      return this.fileExtensionArray[index];
    } else {
      return 'default-extension';
    }

  }

  snackBar() {
    this.openSnackBar("Download will begin automatically", "OK")
  }

  checkChanged(event, index, file) {
    this.fileCheckEvent.emit({ event: event, index: index, data: file })
  }
  getToolTipData(folder) {
    // console.log('folder for tooltip', folder)
    let status = folder.status.isRead ? '' : 'Not Read'
    let shared = folder.status.sharedAt ? moment(folder.status.sharedAt).format('MM/DD/YYYY') : ''
    let read = folder.status.readAt && folder.status.isRead ? '\n Read On: ' + moment(folder.status.readAt).format('MM/DD/YYYY') : ''
    return status + '\n' + 'Shared On: ' + shared + read
  }


}
